import { createSelector } from '@ngrx/store';

import { membersState } from '../root';

export const isMemberPhoneVeryficationCodeInvalid = createSelector(membersState, (members) => members.verifyPhone.hasFailed);
